<!-- PaymentIcon.vue -->
<template>
  <svg :class="iconClass" width="10" height="10" viewBox="0 0 10 10" fill="none">                
    <path d="M8.33335 3.33331L5.15706 6.59967C5.07038 6.68897 4.92967 6.68897 4.84298 6.59967L1.66669 3.33331" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script setup>
defineProps({
  iconClass: {
    type: String,
    default: '',
  }
});
</script>
